import { z } from 'zod';
import { oneOf, pageNum, pageSize } from '../../../navigation/searchParams';

/**
 * The open tab (account or phone numbers), the credit ledger's grouping and
 * paging, and the account's edit dialogs:
 * adjust credits, billing settings, calling rules and API access. Reversing a
 * ledger entry and revoking a key are confirmations, so they stay on the page.
 */
export const platformTenantSearch = z.object({
  tab: oneOf(['account', 'numbers']),
  ledgerGroup: oneOf(['day', 'week', 'month']),
  ledgerPage: pageNum,
  ledgerSize: pageSize,
  modal: oneOf(['adjust-credit', 'billing-settings', 'edit-calling-rules', 'edit-api-access']),
});
